import React, { useEffect, useContext, useState } from 'react';
import { AgendaContext } from '../contexts/AgendaContext';
// Mui components
import { Box } from '@mui/system';
// Components
import HorizontalDivider from '../components/common/HorizontalDivider';
import UserDetails from '../components/Home/UserDetails';
import SeleccionContrato from '../components/Home/SeleccionContrato';
import NuevaSolicitud from '../components/Home/NuevaSolicitud';
import Solicitudes from '../components/Home/Solicitudes';
import ModalConsultorioConnectionBlocked from '../components/Home/Modals/ModalConsultorioConnectionBlocked.home';
import { modales } from '../utils/Constants/Modales';
// ErrorProvider
import { useError } from '../contexts/ErrorProvider.jsx';
import { CONSULTORIO_CONNECTION_BLOCKING_REASON } from '../utils/Constants/consultorioConnectionBlocking';

const isActiveConsultorioConnectionBlock = (reason) =>
  reason === CONSULTORIO_CONNECTION_BLOCKING_REASON.CONSULTORIO_DIGITAL ||
  reason === CONSULTORIO_CONNECTION_BLOCKING_REASON.NO_PUBLISHED_IN_OSDE_CARTILLA;

export default function Home() {
  const {
    prestadoresOsde,
    getDatosContactoPrestador,
    getSolicitudesWithContrato,
    contratoSeleccionado,
    getMotivosRechazo,
    getIcWithContrato
  } = useContext(AgendaContext);

  const { handleError } = useError();

  const [loadingVerificacionCD, setLoadingVerificacionCD] = useState(true);
  const [consultorioConnectionBlockingReason, setConsultorioConnectionBlockingReason] = useState(null);
  const [openModals, setOpenModals] = useState(modales);

  const reportConsultorioConnectionBlocking = (reason, { showModal = false } = {}) => {
    setConsultorioConnectionBlockingReason(reason);
    if (!reason) {
      setOpenModals(modales);
      return;
    }
    if (showModal) {
      setOpenModals({ ...modales, consultorioConnectionBlocked: true });
    }
  };

  const handleCloseConsultorioConnectionModal = () => {
    setOpenModals({ ...modales, consultorioConnectionBlocked: false });
  };

  useEffect(() => {
    const solicitudes = async () => {
      try {
        await getDatosContactoPrestador(contratoSeleccionado);
      } catch (error) {
        handleError({ error: error, description: 'initializeError' });
      }
    };
    getMotivosRechazo();
    if (prestadoresOsde) solicitudes();
  }, [prestadoresOsde, contratoSeleccionado]);

  useEffect(() => {
    if (!prestadoresOsde || !contratoSeleccionado || loadingVerificacionCD) {
      return;
    }
    if (isActiveConsultorioConnectionBlock(consultorioConnectionBlockingReason)) {
      return;
    }

    const solicitudesContrato = async () => {
      try {
        await getSolicitudesWithContrato(contratoSeleccionado);
      } catch (error) {
        handleError({ error: error, description: 'initializeError' });
      }
    };

    solicitudesContrato();
    getIcWithContrato(contratoSeleccionado);
  }, [
    contratoSeleccionado,
    consultorioConnectionBlockingReason,
    loadingVerificacionCD,
    prestadoresOsde
  ]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexGrow: 1 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              maxWidth: '920px',
              mt: 'calc(3rem + 76px)',
              mb: '3rem',
              gap: '2rem'
            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
              <UserDetails />
              <SeleccionContrato
                setLoadingVerificacionCD={setLoadingVerificacionCD}
                onConsultorioConnectionBlocking={reportConsultorioConnectionBlocking}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
              <NuevaSolicitud
                loadingVerificacionCD={loadingVerificacionCD}
                setLoadingVerificacionCD={setLoadingVerificacionCD}
                consultorioConnectionBlockingReason={consultorioConnectionBlockingReason}
                onConsultorioConnectionBlocking={reportConsultorioConnectionBlocking}
              />
              <HorizontalDivider />
              <Solicitudes loadingVerificacionCD={loadingVerificacionCD} />
            </Box>
          </Box>
        </Box>
      </Box>
      <ModalConsultorioConnectionBlocked
        open={openModals.consultorioConnectionBlocked}
        onClose={handleCloseConsultorioConnectionModal}
        blockingReason={consultorioConnectionBlockingReason}
      />
    </Box>
  );
}
